import { PlaceLabels } from 'src/Constants'
import { Logger, Place } from 'wdc-cube'
import { ServiceClient } from './ServiceClient'

const LOG = Logger.get('TelemetryService')

const serviceClient = ServiceClient.singleton()

export class TelemetryService {
    private static INSTANCE = new TelemetryService()

    public static readonly singleton = () => TelemetryService.INSTANCE

    public pageView(place: Place) {
        const root = place.path.length > 0 ? place.path[0] : place

        this.send({
            placeCode: root.name,
            pathName: place.name,
            pageLabel: PlaceLabels[toLabelKey(root)]
        })
    }

    private send(body: Record<string, string | undefined>) {
        serviceClient
            .authRawPost('/api/access-log/event', body)
            .catch((err) => LOG.warn('Falha ao registrar telemetria de acesso', err))
    }
}

function toLabelKey(place: Place): string {
    return place.name.replace(/^\/+/, '')
}
